/* eslint-disable */

import moment from 'moment';

export const setToken = token => {
  let s = JSON.stringify({
    time: parseInt(Date.now() / 1000),
    token: token
  });
  localStorage.setItem('token', s);
};

export const getToken = () => {
  let s = '';
  s = localStorage.getItem('token') || '';
  if (s === '') {
    return '';
  }
  let o = JSON.parse(s);
  if (parseInt(Date.now() / 1000) - o.time > 30 * 24 * 60 * 60 - 60) {
    return '';
  }
  return o.token;
};

export const delToken = () => {
  localStorage.setItem('token', '');
};

export const sortObject = o => {
  var o1 = {};
  var l = Object.keys(o).sort();
  for (var k of l) {
    o1[k] = o[k];
  }
  return o1;
};

export const addNotification = (kind, content) => {
  let o = {
    kind,
    content,
    time: parseInt(Date.now() / 1000)
  };
  let l = [];
  let s = localStorage.getItem('notificationlist') || '';
  if (s !== '') {
    l = JSON.parse(s);
  }
  l.splice(0, 0, o);
  l = l.slice(0, 33); // 最高存储数量
  localStorage.setItem('notificationlist', JSON.stringify(l));
};

export const getNotificationList = () => {
  let s = localStorage.getItem('notificationlist') || '';
  if (s === '') {
    return [];
  }
  let l = JSON.parse(s);
  return l;
};

export const clearNotificationList = () => {
  localStorage.setItem('notificationlist', '');
};
